import { Image } from '@mantine/core'
import logo from '@src/assets/logo/logo512.png'
import styles from '@src/App.module.css'
const Logo = () => {
  return (
    <div className={styles.App}>
      <Image src={logo} className={styles.App_logo} />
      <div className={styles.App_header}>数据分析咨询服务</div>
    </div>
  )
}
export default Logo
